// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__2fVCb","head":"ProcedureTableInfo_head__3QMQj"};